import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createLegalCheckForm(): FormGroup<KaufpreisLegalCheckFormModel> {
  return new FormGroup<KaufpreisLegalCheckFormModel>({
    hasAgreedToElectronicCommunication: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAcceptedPrivacyPolicy: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAcceptedGeneralTermsAndConditions: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasReadInsuranceProductInformationSheet: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAuthorizedSepaDirectDebit: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAcknowledgedRightOfWithdrawal: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasConfirmedProductMeetsWishesAndNeeds: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [Validators.requiredTrue]
    }),

    hasConfirmedVollkaskoInsuranceInAustria: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasConfirmedVehicleWeightBelow_35_T: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [Validators.requiredTrue]
    }),
    hasAcknowledgedCoverageEndAfterTenYears: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [Validators.requiredTrue]
    }),
    hasAcknowledgedCoverageEndAfter_200_000_Km: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [Validators.requiredTrue]
    }),
    hasConfirmedNoCommercialUse: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] })

  });
}

export interface KaufpreisLegalCheckFormModel {
  hasAgreedToElectronicCommunication: FormControl<boolean>;
  hasAcceptedPrivacyPolicy: FormControl<boolean>;
  hasAcceptedGeneralTermsAndConditions: FormControl<boolean>;
  hasReadInsuranceProductInformationSheet: FormControl<boolean>;
  hasAuthorizedSepaDirectDebit: FormControl<boolean>;
  hasAcknowledgedRightOfWithdrawal: FormControl<boolean>;
  hasConfirmedProductMeetsWishesAndNeeds: FormControl<boolean>;

  hasConfirmedVollkaskoInsuranceInAustria: FormControl<boolean>;
  hasConfirmedVehicleWeightBelow_35_T: FormControl<boolean>;
  hasAcknowledgedCoverageEndAfterTenYears: FormControl<boolean>;
  hasAcknowledgedCoverageEndAfter_200_000_Km: FormControl<boolean>;
  hasConfirmedNoCommercialUse: FormControl<boolean>;
}
